import { render } from "./InputSections.vue?vue&type=template&id=4cd2ec74&scoped=true"
import script from "./InputSections.vue?vue&type=script&lang=js"
export * from "./InputSections.vue?vue&type=script&lang=js"

import "./InputSections.vue?vue&type=style&index=0&id=4cd2ec74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cd2ec74"]])

export default __exports__